import { useCallback, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { AuthForm } from '@webapp/account/src/components/auth/form/auth-form';
import { AuthFormSubmit } from '@webapp/account/src/components/auth/form/auth-form-submit';
import { AuthFormText } from '@webapp/account/src/components/auth/form/auth-form-text';
import type { AuthStore } from '@webapp/account/src/components/auth/useAuthFormStore';
import { validateEmail, validateEmpty } from '@webapp/account/src/components/auth/validators';
import { changeEmailUnconfirmed } from '@webapp/account/src/resources/profile/async';
import {
    selectProfileEmail,
    selectProfileFetch,
    selectProfileFetchError,
} from '@webapp/account/src/resources/profile/selectors';

import { useActions } from '@webapp/common/hooks/use-actions';

import { AlertMode } from './lib';

import css from './auth-alert.css';

const RULES = {
    email: (email, _values) => validateEmpty(email) || validateEmail(email),
};

export const AuthAlertEmail: FC<{
    setMode: (mode: AlertMode) => void;
}> = ({ setMode }) => {
    const fetch = useSelector(selectProfileFetch);
    const fetchError = useSelector(selectProfileFetchError);
    const email = useSelector(selectProfileEmail);
    const [triedToFetch, setTriedToFetch] = useState(false);

    const changeEmailUnconfirmedRequest = useActions(changeEmailUnconfirmed);

    const setMessageMode = useCallback(() => setMode(AlertMode.MESSAGE), [setMode]);

    const handleSubmitForm = useCallback(
        (store: AuthStore) => {
            if (!store.hasError) {
                setTriedToFetch(true);
                changeEmailUnconfirmedRequest({ email: store.getValue('email') });
            }
        },
        [changeEmailUnconfirmedRequest],
    );

    //change step
    useEffect(() => {
        if (triedToFetch && !fetch && !fetchError) {
            setMode(AlertMode.MESSAGE);
        }
    }, [fetch, fetchError, triedToFetch, setMode]);

    return (
        <AuthForm onSubmit={handleSubmitForm}>
            <AuthFormText defaultValue={email} label='Email' name='email' rules={RULES.email} />
            <div className={css.actions}>
                <AuthFormSubmit className={css.cancel} type='button' onClick={setMessageMode}>
                    Отмена
                </AuthFormSubmit>
                <AuthFormSubmit className={css.send} disabled={fetch}>
                    {fetch ? 'Загрузка...' : 'Сохранить'}
                </AuthFormSubmit>
            </div>
        </AuthForm>
    );
};
